import React, { useEffect, useState } from 'react';
import WarningTriangle from '../../../../ui/svg/common/warning-triangle';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const OPENED_IN_SESSION = 'sbs-payment-failed-tooltip-opened';

const SBSPaymentTooltip = () => {

    const [isShown, setIsShown] = useState(window.sessionStorage.getItem(OPENED_IN_SESSION) !== 'true');

    useEffect(() => {

        window.sessionStorage.setItem(OPENED_IN_SESSION, 'true');

        setTimeout(() => {
            setIsShown(false);
        }, 10000);
    }, []);

    const sendEvent = () => {
        sendGAEvent('SBS Payment Issue', 'Click Tooltip');
    };

    return (
        <>
            {
                isShown &&
                <div
                    className={`waves-header-account-drop sbs-payment-failed absolute right-0 top-full bg-red-100 text-gray-500 shadow-md rounded text-tiny border`}
                    style={{
                        border: '1px solid #ff4f4f',
                        color: '#F61362',
                    }}>
                    <a
                        href="/account/products"
                        onClick={ sendEvent }
                        className="text-center py-2 flex items-center justify-center no-underline"
                        style={{
                            color: '#F61362',
                        }}>
                        <WarningTriangle classes="mr-1"/>
                        <span className="underline mr-1">Subscription Payment Failed</span>
                        <span>»</span>
                    </a>
                </div>
            }
        </>
    )
};

export default SBSPaymentTooltip;